import React, { useEffect, useState } from "react";
import { Box, Container, Heading, VStack, SimpleGrid } from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logo.svg";
//import { contentful } from "api/contentful/client";
//import { GetChangeCategoriesAndDescriptions } from "api/contentful/queries.gql";
import { getChangesContent } from "api/webservice/content";
import Categories from "./Categories";
import Section from "./Section";
import { BasicLayout } from "layouts";

const Changes: React.FC = () => {
  const [changeCategories, setChangeCategories] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  // @ts-ignore
  const descriptions = changeCategories[activeIndex]
    ? // @ts-ignore
    changeCategories[activeIndex].releasedChanges.map(change => change.fields)
    : [];

  useEffect(() => {
    //contentful.query(GetChangeCategoriesAndDescriptions)
    getChangesContent()
      .then(result => {
      if (!result) return false;
        setChangeCategories(result.items.map((item: any):any => item.fields));
    });
  }, []);

  return (
    <BasicLayout showBackgroundImage backPath="/dashboard">
      <Container maxW="1080px" minH="100vh" px={[4, 12]} centerContent>
        <VStack spacing={8} width="100%">
          <Box w="200px" mt={24}>
            <Logo />
          </Box>
          <Heading size="lg" textAlign="center">
            Changelists
          </Heading>
          <SimpleGrid
            columns={{ sm: 1 }}
            templateColumns={{ sm: "1fr", md: "auto 1fr" }}
            bgColor="gray.700"
            rounded={8}
            color="white"
            width="100%"
            minChildWidth="120px"
            minH={{ md: "xl" }}
            boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
          >
            <Categories
              categories={changeCategories}
              callback={setActiveIndex}
              activeIndex={activeIndex}
            />
            <Section descriptions={descriptions} />
          </SimpleGrid>
        </VStack>
      </Container>
    </BasicLayout>
  );
};

export default Changes;
